<!--
 The label goes inside the switch, which is one button: the whole row then answers a click and
 takes the hover its host paints. `whitespace-normal` undoes the single truncated line the
 library's label box is drawn for — a description needs two.
-->
<mib-switch
  class="w-full justify-between [&>button]:py-2"
  [checked]="checked()"
  [disabled]="pending()"
  (checkedChange)="checkedChange.emit($event)">
  <span class="block whitespace-normal">
    <span class="block text-gray-900">{{ label() }}</span>
    @if (description(); as text) {
      <span class="block text-sm text-gray-500">{{ text }}</span>
    }
  </span>
</mib-switch>
